import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Увековечение памяти Менахема Бегина';

    const images = [
        {
            original: require('../img/events/Begin20050923/begin000.jpg'),
            thumbnail: require('../img/events/Begin20050923/b000.jpg'),
            description: 'Этот дом',
        },
        {
            original: require('../img/events/Begin20050923/begin001.jpg'),
            thumbnail: require('../img/events/Begin20050923/b000.jpg'),
            description: 'ул. Куйбышева, 49',
        },
        {
            original: require('../img/events/Begin20050923/begin002.jpg'),
            thumbnail: require('../img/events/Begin20050923/b002.jpg'),
            description: 'Занавес',
        },
        {
            original: require('../img/events/Begin20050923/begin003.jpg'),
            thumbnail: require('../img/events/Begin20050923/b003.jpg'),
            description: '23 сентября 2005 года',
        },
        {
            original: require('../img/events/Begin20050923/begin004.jpg'),
            thumbnail: require('../img/events/Begin20050923/b004.jpg'),
            description: 'Школьники',
        },
        {
            original: require('../img/events/Begin20050923/begin005.jpg'),
            thumbnail: require('../img/events/Begin20050923/b005.jpg'),
            description: 'Оркестр',
        },
        {
            original: require('../img/events/Begin20050923/begin006.jpg'),
            thumbnail: require('../img/events/Begin20050923/b006.jpg'),
            description: 'Пресса. Слева - главный редактор Брестского Курьера Александров Николай Алексеевич',
        },
        {
            original: require('../img/events/Begin20050923/begin007.jpg'),
            thumbnail: require('../img/events/Begin20050923/b007.jpg'),
            description: 'Перед открытием',
        },
        {
            original: require('../img/events/Begin20050923/begin008.jpg'),
            thumbnail: require('../img/events/Begin20050923/b008.jpg'),
            description: 'В центре руководитель 00 «Холокост» Бляхер Аркадий Моисеевич',
        },
        {
            original: require('../img/events/Begin20050923/begin009.jpg'),
            thumbnail: require('../img/events/Begin20050923/b009.jpg'),
            description: 'Перед открытием',
        },
        {
            original: require('../img/events/Begin20050923/begin010.jpg'),
            thumbnail: require('../img/events/Begin20050923/b010.jpg'),
            description: 'Слово для выступления предоставлено председателю Брестского горисполкома Александру Сергеевичу Палышенкову',
        },
        {
            original: require('../img/events/Begin20050923/begin011.jpg'),
            thumbnail: require('../img/events/Begin20050923/b011.jpg'),
            description: 'Брестчане',
        },
        {
            original: require('../img/events/Begin20050923/begin012.jpg'),
            thumbnail: require('../img/events/Begin20050923/b012.jpg'),
            description: 'Иностранные гости',
        },
        {
            original: require('../img/events/Begin20050923/begin013.jpg'),
            thumbnail: require('../img/events/Begin20050923/b013.jpg'),
            description: 'Участники торжества',
        },
        {
            original: require('../img/events/Begin20050923/begin014.jpg'),
            thumbnail: require('../img/events/Begin20050923/b014.jpg'),
            description: 'Ларри Шенкер. Larry Scheker - руководитель Белорусского Брестского исследовательского центра в США',
        },
        {
            original: require('../img/events/Begin20050923/begin015.jpg'),
            thumbnail: require('../img/events/Begin20050923/b015.jpg'),
            description: 'Открытие мемориальной доски. Право открыть мемориальную доску предоставляется руководителю Белорусского Брестского исследовательского центра в США Ларри Щенкеру, председателю городского общественного объединения «Бриск» Борису Менделевичу Бруку',
        },
        {
            original: require('../img/events/Begin20050923/begin016.jpg'),
            thumbnail: require('../img/events/Begin20050923/b016.jpg'),
            description: 'Открытие мемориальной доски',
        },
        {
            original: require('../img/events/Begin20050923/begin017.jpg'),
            thumbnail: require('../img/events/Begin20050923/b017.jpg'),
            description: 'Открытие мемориальной доски',
        },
        {
            original: require('../img/events/Begin20050923/begin018.jpg'),
            thumbnail: require('../img/events/Begin20050923/b018.jpg'),
            description: 'Открытие мемориальной доски',
        },
        {
            original: require('../img/events/Begin20050923/begin019.jpg'),
            thumbnail: require('../img/events/Begin20050923/b019.jpg'),
            description: 'Открытие мемориальной доски',
        },
        {
            original: require('../img/events/Begin20050923/begin020.jpg'),
            thumbnail: require('../img/events/Begin20050923/b020.jpg'),
            description: 'Открытие мемориальной доски. Во время открытия играет оркестр, идет ритуал - снимается чехол после чего звучат гимны Республики Беларусь и Государства Израиль.',
        },
        {
            original: require('../img/events/Begin20050923/begin021.jpg'),
            thumbnail: require('../img/events/Begin20050923/b021.jpg'),
            description: 'Цви Манн, представитель израильской делегации господин Цви Манн (выступление на английском языке и иврите)',
        },
        {
            original: require('../img/events/Begin20050923/begin022.jpg'),
            thumbnail: require('../img/events/Begin20050923/b022.jpg'),
            description: 'Марченко В. Н., председатель Совета по делам религий и национальностей облисполкома Василий Никифорович Марченко',
        },
        {
            original: require('../img/events/Begin20050923/begin023.jpg'),
            thumbnail: require('../img/events/Begin20050923/b023.jpg'),
            description: 'Брук Б. М., председатель городского еврейского общественного объединения «Бриск» Борис Менделевич Брук',
        },
        {
            original: require('../img/events/Begin20050923/begin024.jpg'),
            thumbnail: require('../img/events/Begin20050923/b024.jpg'),
            description: 'Представитель американского посольства',
        },
        {
            original: require('../img/events/Begin20050923/begin025.jpg'),
            thumbnail: require('../img/events/Begin20050923/b025.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin026.jpg'),
            thumbnail: require('../img/events/Begin20050923/b026.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin027.jpg'),
            thumbnail: require('../img/events/Begin20050923/b027.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin028.jpg'),
            thumbnail: require('../img/events/Begin20050923/b028.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin029.jpg'),
            thumbnail: require('../img/events/Begin20050923/b029.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin030.jpg'),
            thumbnail: require('../img/events/Begin20050923/b030.jpg'),
            description: 'Возложение цветов',
        },
        {
            original: require('../img/events/Begin20050923/begin031.jpg'),
            thumbnail: require('../img/events/Begin20050923/b031.jpg'),
            description: 'Мемориальная доска',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>Еще в 2004 году с Израильским посольством в Беларуси обсуждался вопрос открытия мемориальной доски Менахема Бегина в Бресте. К сожалению, дом, в котором он родился, не сохранился.</p>
                    <p>Менахем Бегин родился 16 августа 1913 года в Бресте.</p>
                    <p>В журнале регистрации лиц, прибывших в Брест на постоянное место жительства за 1921год, отмечено, что Бегины: Вольф, Хася, Рахиль, Герцль и Менахем проживали по ул. Зыгмунтовской, д.59 (ныне ул. Карла Маркса). После этого семья сменила еще несколько мест проживания. Так, уже через год, в 1922-м, Бегины переезжают на улицу Кривую, д. 9 (ныне ул. Дзержинского). В списках избирателей в Брестскую городскую раду за 1928 и 1930 г.г. отмечено, что семья поселилась на ул. Костюшки, д. 11 (сегодня ул. Гоголя). А в 1933 жили на ул. Стефана Батория (сегодня ул. Карбышева). В домовой книге за 1940 год отец и мать значатся в списках проживающих по ул. 1 Мая.</p>
                    <p>Менахем Бегин родился 16 августа 1913 года в Бресте. Окончил юридический факультет Варшавского университета. Доктор юриспруденции. В январе 1939 года возглавляет еврейское молодежное объединение «Бейтар» в Польше. С началом войны бежит из горящей Варшавы в Вильно. Через год его арестовывает НКВД. Приговорен к 8 годам лагерей. В1941 году досрочно освобожден и в составе армии Андерса, сформированной на территории СССР, прибыл в Палестину. После демобилизации стал одним из руководителей подпольной организации, которая подняла восстание против британских властей. С 1948 по 1977 год возглавляет ряд оппозиционных партийных блоков. Член парламента и правительства. С 1977 по 1983 год — премьер-министр Израиля. Лауреат Нобелевской премии мира. Считал себя учеником Зеэва Жеботинского. Сторонник твердой политической линии по отношению к арабским государствам. Убежденный демократ, придерживался либеральных взглядов в вопросах экономики. Написал несколько автобиографических книг. Умер в 1992 году.</p>
                    <p>Несомненно, атмосфера межвоенного Бреста сыграла важную роль в развитии юного Бегина. Судите сами. В то время как в советской Белоруссии полыхал антирелигиозный пожар, а в нацистской Германии готовились к физическому уничтожению еврейства, в польском Бресте существовали 40 (!)синагог, религиозные школы, десятки общественных организаций, несколько газет. Евреи Бреста, составлявшие более половины горожан, жили довольно сплоченно.</p>
                    <p>Begin, Menachem (1913-1992), Israeli prime minister (1977-1983), who in 1979 signed the first peace treaty between Israel and an Arab country (Egypt). Begin was born in Brest-Litovsk, Russia (now Brest, Belarus).</p>
                    <p>По данным опроса социологического института Ротем в 2004 году, 32,8 процента израильтян полагают, что самым великим лидером в истории Государства Израиль был его шестой глава правительства Менахем Бегин. 32 процента отдали пальму первенства первому главе правительства Давиду Бен-Гуриону, 14,1 процента – Ицхаку Рабину.</p>
                    <p>В 1978 году Менахем Бегин стал лауреатом Нобелевской премии мира. $85 тысяч премии он передал в фонд помощи детям.</p>
                    <p>Бегин в своей Нобелевской речи сказал: «Эта премия полагается не мне — она полагается моему народу за великие страдания, выпавшие на его долю, за тяжкие жертвы, которые он понес, за его любовь и страстное стремление к миру».</p>
                    <p>В 1939 году Менахем становится руководителем «Бейтара» в Польше. Приближающаяся война волнует Бегина. Он лихорадочно предпринимает попытки подготовиться к катастрофе. Выступая в Варшаве, он говорит: «Ничего хорошего ждать от этого мира нельзя. Это жестокий мир, который понимает только язык силы». Менахем предлагает польскому правительству дать согласие на создание еврейских вооруженных отрядов. Но получает отказ. Из горящей Варшавы с женой Ализой он успевает уехать в Вильно. В Брест Менахем больше так никогда и не вернется.</p>
                </div>
            </div>
        </>
    );
}